import Vue from 'vue'

function fetch (url, options = {}) {
  const {signal, ...opts} = options

  return new Promise((resolve, reject) => {
    if (signal) {
      signal.$on('abort', () =>
        reject(new Error('Request aborted'))
      )
    }

    window.fetch(url, opts)
      .then(resolve)
      .catch(reject)
  })
}

export const http = Vue.prototype.$http = {
  get (url, options = {}) {
    return fetch(url, {
      ...options,
      method: 'GET'
    })
  },

  post (url, data, options = {}) {
    return fetch(url, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data)
    })
  },

  signal () {
    return new Vue({
      data: {
        aborted: false
      },
      watch: {
        aborted () {
          if (this.aborted) {
            this.$emit('abort')
          }
        }
      },
      methods: {
        abort () {
          this.aborted = true
        }
      }
    })
  }
}
